<template>
  <div class="b-card-container flex-1">
    <div class="bc-header-container">
      <div class="bc-header">
        Filter Detail
      </div>
      <div class="bc-button-container">
        <button
          class="edit-btn"
          @click="toggleActionModal(true, 'add-filter')"
        >
          + Add Unmonitored Filter
        </button>
      </div>
    </div>
    <div class="filter-details-container">
      <div class="filter-table-headers sac__font-14 n70 semi-bold">
        <div>System</div>
        <div>Brand</div>
        <div>Size(in)</div>
        <div>Quality</div>
        <div>Location</div>
        <div>Vent Location</div>
        <div>Monitored</div>
        <div>Life</div>
        <div>Last Replaced</div>
        <div />
      </div>
      <div class="filter-table-data sac__font-14">
        <div
          v-for="(f, idx) in filters"
          :key="idx"
          class="filter-table-rows"
        >
          <div>
            {{ f.system || 'None' }}
          </div>
          <div>
            {{ f.brand || '--' }}
          </div>
          <div>
            <div v-if="f.sbsHeight">
              {{ sbsFilterSize(f) }}
            </div>
            <div v-else>
              {{ f.width }}x{{ f.height }}x{{ f.thickness }}
            </div>
          </div>
          <div>
            {{ f.merv }}
          </div>
          <div>
            {{ f.location }}
          </div>
          <div>
            {{ f.ventLocation }}
          </div>
          <div>
            <div v-if="f.monitored">
              {{ f.uid ? `...${f.uid.substring(15, 20)}-${f.did}` : 'Yes' }}
            </div>
            <div v-else>
              No
            </div>
          </div>
          <div :class="[determineFilterStatus(f)]">
            {{ getFilterLife(f) }}
          </div>
          <div>
            {{ dateWithoutHour(f.lastReplaced, dateAndYearFormat) }}
          </div>
          <div class="grid-column ai-c gap-10">
            <button
              v-if="adminRole !== 'viewer'"
              class="filter-row-replace"
              @click="toggleActionModal(true, 'replace-filter', f)"
            >
              Replace
            </button>
            <button
              v-if="adminRole !== 'viewer'"
              class="filter-row-edit"
              @click="toggleActionModal(true, 'edit-filter', f)"
            >
              <img
                src="@shared/assets/img/general/edit.svg"
                class="img-size-20"
                alt="edit"
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'FilterDetail',
  mixins: [customerDetailMixin, unitPreferencesMixin],
};
</script>

<style lang="scss" scoped>
.filter-details-container {
  padding: 10px;
  background-color: $WHITE;
  max-height: 300px;
  .filter-table-headers {
    grid-template-columns: repeat(10, 1fr);
    display: grid;
    width: 100%;
    padding: 8px 0;
    gap: 1rem;
    white-space: nowrap;
    justify-items: center;
    border-bottom: 2px solid $N5;
  }

  .filter-table-data {
    max-height: 190px;
    overflow: auto;
    .filter-table-rows {
      grid-template-columns: repeat(10, 1fr);
      display: grid;
      width: 100%;
      padding: 10px;
      gap: 1rem;
      justify-items: center;
      &:nth-child(even) {
        background-color: $NBLUE5;
      }

      .filter-row-edit {
        text-align: center;
        border-radius: 6px;
        color: $N100;
        font-size: 14px;
      }

      .filter-row-replace {
        padding: 4px 12px;
        background-color: $NBLUE100;
        text-align: center;
        border-radius: 6px;
        color: $WHITE;
        font-size: 12px;
        height: fit-content;
      }
    }
  }
}
</style>
